/** 分 → 「¥ 1,299.00」 */
export function formatPrice(cents: number, currency = "¥"): string {
  const yuan = (cents / 100).toFixed(2);
  const [int, frac] = yuan.split(".");
  return `${currency} ${int.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${frac}`;
}
